import { useWidgetContext } from '../useWidgetContext'
import { useAppSelector } from '../../store/store'
import { selectWidgetById } from '../../store/widgets'

export const useActiveNotification = (name: string) => {
  const { widgetId } = useWidgetContext()
  const notification = useAppSelector(state => selectWidgetById(state, widgetId).notification)
  return (notification?.name === name && notification.message) || null
}
